export default {
  en: {user_goal: "CBSE", user_exam: "10th CBSE"},
  kn: {user_goal: "Karnataka Board", user_exam: "10th Karnataka State Board"},
  bn: {user_goal: "West Bengal Board", user_exam: "10th West Bengal Board"},
  gu: {user_goal: "Gujarat Board", user_exam: "10th Gujarat Board"},
  or: {user_goal: "Odisha Board", user_exam: "10th Odisha Board"},
  te: {user_goal: "Telangana State Board", user_exam: "10th Telangana State Board"},
  ta: {user_goal: "Tamil Nadu State Board", user_exam: "10th Tamil Nadu State Board"},
  ml: {user_goal: "Kerala Board", user_exam: "10th Kerala Board"},
  mr: {user_goal: "Maharashtra Board", user_exam: "10th Maharashtra Board"},
  pa: {user_goal: "Punjab Board", user_exam: "10th Punjab Board"},
  as: {user_goal: "Assam Board", user_exam: "10th Assam Board"}
}
